import React from "react";
import StationToWiseSummaryReport from "../StationToWiseSummaryReport";


export default function StationToWiseReportPage({ sessionObject }) {
  if (
    !sessionObject.sessionVariables["modules"].includes("station-to-wise-summary")
  ) {
    return null;
  }

  return (
    <div className="page-challan">
      <StationToWiseSummaryReport sessionObject={sessionObject} />
    </div>
  );
}
